import React, { useState } from "react";
import FormAside from "./FormAside";
import PaymentForm from "./PaymentForm";
import { Form } from "react-router-dom";
import FormNotification from "./FormNotification";

function UpcomingPaymentDates() {

  const [paid, setPaid] = useState("");
  const [balance, setBalance] = useState("");
  const [Screenshot, setScreenshot] = useState("")


  const handlePaidChange = (e) => {
    setPaid(e.target.value)
  }
  const handleBalanceChange = (e) => {
    setBalance(e.target.value)
  }
  const screenshotChange = (e) => {
    setScreenshot(e.target.value)
  }

  const paymentData = [
    {
      schoolName: "cleezo School",
      dueDate: "10-04-2026",
      totalAmount: 50000,
      paidAmount: 30000,
      balanceAmount: 20000,
    },
    {
      schoolName: "class School",
      dueDate: "15-04-2026",
      totalAmount: 70000,
      paidAmount: 40000,
      balanceAmount: 30000,
    },
  ];

  return (
    <div className="mainBlock" style={{ padding: "20px" }}>
      <FormNotification />
      <FormAside />

      <h2 className="upcomingpayment-header">Upcoming PaymentDates</h2>

      <div className="upcoming-payments-div">
        <table border="1" cellPadding="10" cellSpacing="0" width="100%" className="upComing-payments-table">
          <thead>
            <tr>
              <th>School Name</th>
              <th>Due Date</th>
              <th>Total Amount</th>
              <th>Paid Amount</th>
              <th>Balance Amount</th>

            </tr>
          </thead>
          <tbody>
            {paymentData.map((payment, index) => (
              <tr key={index}>
                <td>{payment.schoolName}</td>
                <td>{payment.dueDate}</td>
                <td>{payment.totalAmount}</td>
                <td>{payment.paidAmount}</td>
                <td>{payment.balanceAmount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


      <PaymentForm />
    </div>
  );
}

export default UpcomingPaymentDates;